import { useQuery } from 'hooks/useCustomQuery';
import { useQueryClient } from '@tanstack/react-query';

export const useGetData = ({
    queryKey,
    fetchFunction,
    transformData,
    setData,
    enabled = true,
    fetchFunctionParams = [],
    invalidateQuery,
    staleTime,
}) => {
    const queryClient = useQueryClient();
    return useQuery({
        queryKey: queryKey,
        queryFn: async () => {
            let fetchedData = await fetchFunction(...fetchFunctionParams);

            if (transformData) {
                fetchedData = transformData(fetchedData);
            }

            if (setData) {
                setData(fetchedData);
            }

            if (invalidateQuery) {
                queryClient.invalidateQueries(queryKey);
            }

            return fetchedData;
        },
        refetchOnWindowFocus: false,
        enabled: enabled,
        staleTime: staleTime,
    });
};
